import { createSlice } from "@reduxjs/toolkit";
import Axios from "../../utils/axiosInstance";

const initialState = {
  monthlyAnalysis: [],
};

const slice = createSlice({
  name: "report",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET
    getMonthlyAnalysisListSuccess(state, action) {
      state.isLoading = false;
      state.monthlyAnalysis = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow } = slice.actions;

// ----------------------------------------------------------------------

export function getMonthlyAnalysisList(fromDate, toDate, categoryId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(
        `/analysis/monthly?from_date=${fromDate}&to_date=${toDate}&categoryId=${categoryId}`
      );
      dispatch(slice.actions.getMonthlyAnalysisListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
